import { h } from 'preact'
import styles from './MatchStatus.module.css'
import { IMatchData } from '../../lib/model'

const statusCodes = {
  Slutt: [1, 16, 17],
  Avlyst: [4, 5],
  Plannlagt: [2, 3, 6],
  Pågår: [7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
}

interface Props {
  matchData: IMatchData
}

export function MatchStatus(props: Props) {
  const status = statusLabel(props.matchData.matchStatusId)
  if (status === 'Plannlagt') {
    return (
      <div class={styles['dh-fotball-banner__match-status']}>
        <a href={props.matchData.resultLink}>
          <time>{formatTime(props.matchData.timestamp)}</time>
          <div>{props.matchData.tvChannel}</div>
        </a>
      </div>
    )
  } else {
    return (
      <div class={styles['dh-fotball-banner__match-status']}>
        <a href={props.matchData.resultLink}>
          <div class={status === 'Pågår' ? styles['dh-fotball-banner__match-status-ongoing'] : ''}>
            {status}
          </div>
          <div>{props.matchData.tvChannel}</div>
        </a>
      </div>
    )
  }
}

function statusLabel(statusCode: number) {
  for (let statusCodesKey in statusCodes) {
    if (statusCodes[statusCodesKey].includes(statusCode)) {
      return statusCodesKey
    }
  }
  return 'Plannlagt'
}

function formatTime(matchDate) {
  if (!matchDate) {
    return matchDate
  }
  const date = new Date(matchDate)
  const minutes = `0${date.getMinutes()}`.slice(-2)
  return `${date.getHours()}:${minutes}`
}
